export const type={    SWITCH_MENU: 'SWITCH_MENU'}